import { render, staticRenderFns } from "./UpcomingListHistory.vue?vue&type=template&id=04ccd015&lang=pug&"
import script from "./UpcomingListHistory.vue?vue&type=script&lang=ts&"
export * from "./UpcomingListHistory.vue?vue&type=script&lang=ts&"
import style0 from "./UpcomingListHistory.vue?vue&type=style&index=0&id=04ccd015&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports